// import { useState, useEffect, useCallback, useRef } from "react";
// import { GoogleGenerativeAI } from "@google/generative-ai";

// const API_KEY = process.env.REACT_APP_GEMINI_KEY;
// const model = "gemini-2.5-flash";

// export const useAISuggestion = (fitnessData, dateRange) => {
//   const [aiResponse, setAiResponse] = useState({
//     title: "",
//     description: "",
//     isLoading: false,
//     isStreaming: false,
//     error: null,
//   });
//   const [genAI, setGenAI] = useState(null);
  
//   // Track previous fitnessData to detect changes
//   const prevFitnessDataRef = useRef();
//   const isInitialMount = useRef(true);

//   // Initialize Gemini AI
//   useEffect(() => {
//     if (API_KEY) {
//       const genAIInstance = new GoogleGenerativeAI(API_KEY);
//       setGenAI(genAIInstance);
//     } else {
//       console.error("Gemini API key is missing");
//       setAiResponse(prev => ({
//         ...prev,
//         error: "AI service is currently unavailable. Please try again later."
//       }));
//     }
//   }, []);

//   // Format date for display
//   const formatDate = useCallback((date) => {
//     if (!date) return "N/A";
//     const d = new Date(date);
//     return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
//   }, []);

//   // Format active time from string like "2h 30m" to just minutes
//   const parseActiveMinutes = useCallback((activeTime) => {
//     if (!activeTime) return "0";
//     if (activeTime.includes("h")) {
//       const parts = activeTime.split("h");
//       const hours = parseInt(parts[0]) || 0;
//       const minutes = parts[1] ? parseInt(parts[1].replace("m", "").trim()) || 0 : 0;
//       return (hours * 60 + minutes).toString();
//     } else if (activeTime.includes("m")) {
//       return parseInt(activeTime.replace("m", "").trim()) || "0";
//     }
//     return "0";
//   }, []);

//   // Generate AI suggestion based on fitness data
//   const generateAISuggestion = useCallback(async (forceRefresh = false) => {
//     if (!genAI || !fitnessData || aiResponse.isLoading) return;

//     setAiResponse(prev => ({
//       ...prev,
//       isLoading: true,
//       isStreaming: true,
//       error: null,
//     }));

//     try {
//       const geminiModel = genAI.getGenerativeModel({ model });

//       const prompt = `Generate a personalized fitness suggestion for the user for this week.

// User's weekly stats:
// - Steps: ${fitnessData?.totalSteps || "0"}
// - Calories burned: ${fitnessData?.caloriesBurnt || "0 kcal"}
// - Active minutes: ${parseActiveMinutes(fitnessData?.activeTime) || "0"} minutes
// - Active days: ${dateRange?.daysSelected || 0}
// - Goal progress: ${fitnessData?.weeklyGoalProgress || "0"}%
// - Date Range: ${dateRange?.startDate ? formatDate(dateRange.startDate) : ""} to ${dateRange?.endDate ? formatDate(dateRange.endDate) : ""}

// Base the suggestion on their actual performance. If they're doing well, congratulate and encourage to maintain.
// If they're below target, give motivating tips to improve. Make it specific to their numbers.

// Please provide a suggestion with:
// 1. A SHORT TITLE (max 10 words)
// 2. A DESCRIPTION (max 50 words)

// Format your response exactly as:
// TITLE: [your title here]
// DESCRIPTION: [your description here]

// Do not include any other text, markdown, or formatting.`;

//       const result = await geminiModel.generateContentStream(prompt);
//       let fullResponse = "";
//       let title = "";
//       let description = "";

//       // Stream the response
//       for await (const chunk of result.stream) {
//         const chunkText = chunk.text();
//         fullResponse += chunkText;

//         // Parse title and description from streaming response
//         const titleMatch = fullResponse.match(/TITLE:\s*(.*?)(?=DESCRIPTION:|$)/s);
//         const descMatch = fullResponse.match(/DESCRIPTION:\s*(.*)/s);

//         if (titleMatch) title = titleMatch[1].trim();
//         if (descMatch) description = descMatch[1].trim();

//         setAiResponse(prev => ({
//           ...prev,
//           title: title || "Analyzing your progress...",
//           description: description || "Generating personalized suggestions...",
//           isStreaming: true,
//         }));
//       }

//       // Final parsing after stream completes
//       const titleMatch = fullResponse.match(/TITLE:\s*(.*?)(?=DESCRIPTION:|$)/s);
//       const descMatch = fullResponse.match(/DESCRIPTION:\s*(.*)/s);

//       if (titleMatch) title = titleMatch[1].trim();
//       if (descMatch) description = descMatch[1].trim();

//       // Clean up the responses
//       title = title.replace(/["']/g, '').trim();
//       description = description.replace(/["']/g, '').trim();

//       // Set final state
//       setAiResponse({
//         title: title || "Great Progress!",
//         description: description || "Keep up the good work with your fitness journey!",
//         isLoading: false,
//         isStreaming: false,
//         error: null,
//       });

//       // Update ref with current fitness data
//       prevFitnessDataRef.current = fitnessData;

//     } catch (error) {
//       console.error("Error generating AI suggestion:", error);
//       setAiResponse({
//         title: "Stay Active!",
//         description: "Consistency is key to reaching your fitness goals. Keep moving every day!",
//         isLoading: false,
//         isStreaming: false,
//         error: "Unable to generate AI suggestions. Showing default message.",
//       });
//     }
//   }, [fitnessData, genAI, dateRange, formatDate, parseActiveMinutes, aiResponse.isLoading]);

//   // Auto-generate suggestion ONLY when fitness data changes (not on dateRange changes)
//   useEffect(() => {
//     if (!fitnessData || !genAI || aiResponse.isLoading) return;

//     // Check if fitnessData has meaningfully changed
//     const fitnessDataChanged = JSON.stringify(prevFitnessDataRef.current) !== JSON.stringify(fitnessData);
    
//     // Don't trigger on initial mount (when prevFitnessDataRef.current is undefined)
//     const isInitial = isInitialMount.current;
    
//     if (isInitial) {
//       isInitialMount.current = false;
//     }

//     // Regenerate if fitness data changed (but not on initial mount when we have no response)
//     if ((fitnessDataChanged && !isInitial) || !aiResponse.title) {
//       // Clear previous response
//       setAiResponse({
//         title: "",
//         description: "",
//         isLoading: false,
//         isStreaming: false,
//         error: null,
//       });
      
//       // Small delay to ensure state is cleared
//       const timer = setTimeout(() => {
//         generateAISuggestion();
//       }, 100);
      
//       return () => clearTimeout(timer);
//     }
//   }, [fitnessData, genAI, aiResponse.isLoading, aiResponse.title, generateAISuggestion]); // Removed dateRange from deps

//   return {
//     aiResponse,
//     generateAISuggestion: () => generateAISuggestion(true),
//     regenerateSuggestion: () => {
//       // Force clear and regenerate
//       setAiResponse({
//         title: "",
//         description: "",
//         isLoading: false,
//         isStreaming: false,
//         error: null,
//       });
//       setTimeout(() => generateAISuggestion(true), 50);
//     }
//   };
// };



import { useState, useEffect, useCallback, useRef } from "react";
import { GoogleGenerativeAI } from "@google/generative-ai";
import { useUserData } from "@context/OAuth/AuthContext";

const API_KEY = process.env.REACT_APP_GEMINI_KEY;
// Note: Ensure model name is correct for your plan (e.g., "gemini-1.5-flash")
const modelName = "gemini-2.5-flash";

export const useAISuggestion = (fitnessData, dateRange) => {
  const {user} = useUserData();

  const [aiResponse, setAiResponse] = useState({
    description: "",
    improvementTip: "",
    isLoading: false,
    isStreaming: false,
    error: null,
  });
  const [genAI, setGenAI] = useState(null);
  
  const prevFitnessDataRef = useRef();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (API_KEY) {
      const genAIInstance = new GoogleGenerativeAI(API_KEY);
      setGenAI(genAIInstance);
    } else {
      setAiResponse(prev => ({
        ...prev,
        error: "AI service is currently unavailable."
      }));
    }
  }, []);

  const formatDate = useCallback((date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }, []);

  const parseActiveMinutes = useCallback((activeTime) => {
    if (!activeTime) return "0";
    if (typeof activeTime !== 'string') return activeTime.toString();
    if (activeTime.includes("h")) {
      const parts = activeTime.split("h");
      const hours = parseInt(parts[0]) || 0;
      const minutes = parts[1] ? parseInt(parts[1].replace("m", "").trim()) || 0 : 0;
      return (hours * 60 + minutes).toString();
    } else if (activeTime.includes("m")) {
      return parseInt(activeTime.replace("m", "").trim()) || "0";
    }
    return activeTime;
  }, []);

  const generateAISuggestion = useCallback(async () => {
    if (!genAI || !fitnessData || aiResponse.isLoading) return;

    setAiResponse(prev => ({
      ...prev,
      isLoading: true,
      isStreaming: true,
      error: null,
    }));

    try {
      const geminiModel = genAI.getGenerativeModel({ model: modelName });

      const prompt = `User Stats: ${fitnessData?.totalSteps} steps, ${fitnessData?.caloriesBurnt} calories, ${parseActiveMinutes(fitnessData?.activeTime)} mins active.
      
      Provide fitness coaching advice based on these numbers. Focus on how these steps impact fat loss and cardiovascular health.
      Respond in ${user?.language}.
      Return exactly two fields in this format:
      ADVICE: [One paragraph, max 20 words. Explain why their current step level is good for their health/trends.]
      TIP: [One short actionable sentence, max 15-18 words. Suggest a specific walk or small activity.]

      No titles, no markdown.`;

      const result = await geminiModel.generateContentStream(prompt);
      let fullResponse = "";

      for await (const chunk of result.stream) {
        fullResponse += chunk.text();

        const adviceMatch = fullResponse.match(/ADVICE:\s*(.*?)(?=TIP:|$)/s);
        const tipMatch = fullResponse.match(/TIP:\s*(.*)/s);

        setAiResponse(prev => ({
          ...prev,
          description: adviceMatch ? adviceMatch[1].trim() : "Analyzing trends...",
          improvementTip: tipMatch ? tipMatch[1].trim() : "Thinking of a tip...",
          isStreaming: true,
        }));
      }

      setAiResponse(prev => ({
        ...prev,
        isLoading: false,
        isStreaming: false,
      }));

      prevFitnessDataRef.current = fitnessData;

    } catch (error) {
      console.error("Error:", error);
      setAiResponse({
        description: "Your movement supports fat loss and cardiovascular health based on your weekly trends.",
        improvementTip: "Try a 10 minute brisk walk this evening to stay on track.",
        isLoading: false,
        isStreaming: false,
        error: "Default suggestion loaded.",
      });
    }
  }, [fitnessData, genAI, parseActiveMinutes]);

  useEffect(() => {
    if (!fitnessData || !genAI || aiResponse.isLoading) return;

    const fitnessDataChanged = JSON.stringify(prevFitnessDataRef.current) !== JSON.stringify(fitnessData);
    const isInitial = isInitialMount.current;
    
    if (isInitial) {
      isInitialMount.current = false;
    }

    if ((fitnessDataChanged && !isInitial) || !aiResponse.description) {
      const timer = setTimeout(() => {
        generateAISuggestion();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [fitnessData, genAI, generateAISuggestion]);

  return {
    aiResponse,
    regenerateSuggestion: generateAISuggestion
  };
};